/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description React Hook useBatchPostPaymentHistory
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';
import { BATCH_POST_PAYMENT_ADF_FIELD_MAP } from 'utils/adfUtils';
import { updateApiParamsCriteria } from 'utils/advancedFilterUtils';

/**
 * use batch post payment history hook
 * @returns {UseQueryResult} useBatchPostPaymentHistory
 */

const useBatchPostPaymentHistory = (
	requestParams: PatientPayment.IBatchPostPaymentHistoryRequest,
): UseQueryResult<PatientPayment.IBatchPostPaymentHistoryResponse> => {
	return useQuery({
		queryKey: [QUERY_KEYS.batchPostPaymentHistory, { requestParams }],
		queryFn: async () => {
			const { data } = await api.FHIRClaimApi.getPostPaymentHistory(
				updateApiParamsCriteria(requestParams, BATCH_POST_PAYMENT_ADF_FIELD_MAP),
			);
			return data;
		},
		refetchInterval: 1000 * 60 * 1, // 1 minute
	});
};

export default useBatchPostPaymentHistory;
